module.exports = __webpack_public_path__ + "static/media/tsxlogo200.ede0b63b.png";